import styled, { css } from "styled-components";
import { device } from "../../Utils/device";
import { themes } from "../../Utils/themes";

export enum VariantType {
  Small = "small",
  Medium = "medium",
}

const inputBaseStyle = css`
  font-size: ${themes.textSize.s3};
  border: 1px solid ${themes.colors.border};
  border-radius: 5px;
  padding: 10px;
  max-width: 500px;

  @media ${device.tablet} {
    font-size: ${themes.textSize.m1};
    padding: 12px 16px;
  }
`;

export const Section = styled.div`
  padding-top: 80px;
  margin: 0 20px;
  @media ${device.desktop} {
    margin: 0 auto;
    max-width: 800px;
  }
`;

export const FormItemWrap = styled.div`
  width: 100%;
  display: inline-grid;
  margin-top: 20px;
  @media ${device.desktop} {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
  }
`;

export const FormItemLabel = styled.label`
  font-size: ${themes.textSize.s3};
  font-weight: normal;
  color: ${themes.colors.text};
  width: 100%;
  max-width: 300px;
  @media ${device.tablet} {
    font-size: ${themes.textSize.m2};
  }
`;

export const Input = styled.input<{ variant: VariantType }>`
  ${inputBaseStyle}
  max-width: 100%;
  @media ${device.tablet} {
    margin: 0;
    width: ${({ variant }) => {
      switch (variant) {
        case "small":
          return "150px";
        case "medium":
          return "100%";
      }
    }};
  }
`;

export const OptionLabel = styled.div`
  font-size: ${themes.textSize.s3};
  display: inline-flex;
  align-items: center;
  position: relative;
  width: 100%;
  max-width: 100%;

  &:after {
    position: absolute;
    right: 15px;
    width: 10px;
    height: 7px;
    background-color: #535353;
    clip-path: polygon(0 0, 100% 0, 50% 100%);
    content: "";
    pointer-events: none;
  }
`;

export const OptionSelect = styled.select`
  ${inputBaseStyle}
  appearance: none;
  border-radius: 5px;
  background-color: #fff;
  color: #333333;
  width: 100%;
  -webkit-appearance: none;
  cursor: pointer;
  max-width: 100%;

  @media ${device.desktop} {
  }
`;

export const OptionValue = styled.option`
  ${inputBaseStyle}
`;

export const LinkButtonWrap = styled.div`
  display: flex;
  justify-content: center;
  margin: 40px 0;
  width: 100%;
  height: 40px;

  @media ${device.desktop} {
    height: auto;
    width: auto;
    min-height: 50px;
    height: 46px;
  }
`;

export const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${themes.colors.filled};
  font-weight: bold;
  border-radius: 8px;
  width: 100%;
  max-width: 250px;
  padding: 5px 10px;
  white-space: nowrap;
  font-size: ${themes.textSize.m1};
  color: ${themes.colors.white};
  border: none;
  @media ${device.desktop} {
    font-size: ${themes.textSize.m2};
    border-radius: 12px;
    max-width: 500px;
  }
`;

export const AddButton = styled.button`
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  height: 100%;
  padding: 5px 10px;
  white-space: nowrap;
  font-size: 16px;
  color: ${themes.colors.text};
  cursor: pointer;
  max-width: 250px;
  margin: 0 auto;
`;
